<div class="w-100-p" *ngIf="dataSource">
    <mat-table #table [dataSource]="dataSource">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef class="pr-12">{{ 'GENERAL.PROPERTY.NAME' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let performanceProfilePersonalReview" class="pr-12">
                <span class="font-medium text-truncate min-w-0">{{ performanceProfilePersonalReview.name }}</span>
            </mat-cell>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef class="pr-12">{{ 'GENERAL.PROPERTY.TYPE' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let performanceProfilePersonalReview" class="pr-12">
                <span class="text-truncate min-w-0">{{ performanceProfilePersonalReview.type.name | translate }}</span>
            </mat-cell>
        </ng-container>

        <!-- Team Column -->
        <ng-container matColumnDef="team">
            <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm> {{ 'TEAMS.TITLE.SINGULAR' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let performanceProfilePersonalReview" fxHide fxShow.gt-sm>
                <p class="text-truncate min-w-0 mr-4">
                    {{ performanceProfilePersonalReview.team?.name }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm> {{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let performanceProfilePersonalReview" fxHide fxShow.gt-sm>
                <span
                    class="py-4 px-12 whitespace-nowrap uppercase rounded-full tracking-wider text-xs"
                    [style.color]="performanceProfilePersonalReview.status | getStatus: performancePersonalReviewStatus:'color'"
                    [style.background-color]="performanceProfilePersonalReview.status | getStatus: performancePersonalReviewStatus:'bgColor'"
                >
                    {{ performanceProfilePersonalReview.status | getStatus: performancePersonalReviewStatus:'translationLabel' | translate }}
                </span>
            </mat-cell>
        </ng-container>

        <!-- Due Date Column -->
        <ng-container matColumnDef="dueDate">
            <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm> {{ 'GENERAL.PROPERTY.DUE_DATE' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let performanceProfilePersonalReview" fxHide fxShow.gt-sm>
                <p class="whitespace-nowrap mr-4">
                    {{ performanceProfilePersonalReview.dueDate | date: 'shortDate' }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let performanceProfilePersonalReview">
                <div fxLayout="row" fxLayoutAlign="end center" class="shrink-0">
                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu" xPosition="before">
                        <button mat-menu-item aria-label="move" (click)="openMoveToTeamDialog(performanceProfilePersonalReview)">
                            <mat-icon svgIcon="folder_move" class="mr-16"></mat-icon>
                            <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_NEW_TEAM' | translate }}</span>
                        </button>
                    </mat-menu>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
            *matRowDef="let performanceProfilePersonalReview; columns: displayedColumns"
            matRipple
            class="relative group"
            [ngClass]="{
                pointer: canOpenPerformanceReviews && (canAccessInputPhase || performanceProfilePersonalReview.status === PerformancePersonalReviewStatusEnum.COMPLETED),
                'hover:bg-gray-50': canOpenPerformanceReviews && (canAccessInputPhase || performanceProfilePersonalReview.status === PerformancePersonalReviewStatusEnum.COMPLETED)
            }"
            (click)="openPerformanceReviewDetailsPage(performanceProfilePersonalReview)"
        >
        </mat-row>
    </mat-table>

    <mat-paginator persistPageSize="preformance-profile-personal-reviews-list.preformance-profile-personal-reviews-list" [length]="performanceProfilePersonalReviewsStateTotalCount$ | async" [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
</div>
